var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"messages-view-layout"},[_c('SessionsBar'),_c('MainPanel')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }